import React, { Component } from 'react';
import JsonapiClient from '@holidayextras/jsonapi-client';
import { authService } from '../../utils/auth-service';

const hasJSONAPIClient = WrapperComponent => class HasJSONAPIClient extends Component {
  constructor(props) {
    super(props);
    this.jsonAPIClient = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
      header: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }

  render() {
    return <WrapperComponent {...this.props} jsonAPIClient={this.jsonAPIClient} />;
  }
};

export default hasJSONAPIClient;



/** WEBPACK FOOTER **
 ** ./src/hocs/has-jsonapi-client/index.js
 **/